import React, {useState, useRef, useEffect} from "react";
import { StyledBlock } from "../containers";
import { Label } from "../generic";
import { StrNum, ISelectItems } from "interfaces/intarfaces";
import { ArrowDown } from "components/PopupMenu/styles";
import useOnClickOutside from "utils/hooks/useOnClickOutside";
import useHover from "utils/hooks/useHover";
import {
  StyledPrefix,
  ContainerSelectedValue,
  ItemsMultiSelect,
  ItemLi,
  PopupSelect,
} from "../MultiSelect/styles";
import { sortTop } from "utils/fetchMapInfo";
import {useTranslation} from "react-i18next";

export interface ISelect extends React.HTMLAttributes<HTMLSelectElement> {
  title?: string;
  items?: ISelectItems[];
  topValues?: string[];
  placeholder?: string;
  changeItem: (x: StrNum) => void;
  value?: StrNum;
  w?: string;
  grow?: string;
  p?: string;
  id?: string;
  disabled?: boolean;
  required?: boolean;
  handleLeave?: any
  handleClick?: any
}

const Select: React.FC<ISelect> = ({
  title,
  items,
  topValues = [],
  value,
  placeholder,
  changeItem,
  w = "100%",
  grow = "0",
  p,
  id,
  required = false,
  disabled,
  handleLeave,
  handleClick
}) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();

  useOnClickOutside(ref, () => {
    !isHovered && setShow(false)
  });

  const getLabel = () => {
    let label = placeholder;
    const item = items?.filter((item) => item.value === value);
    if (item && item?.length > 0) label = item[0].label;
    return label;
  };
  const {i18n} = useTranslation('home')

  useEffect(() => {
    handleClick && changeItem(i18n.language)
    handleClick && handleClick(i18n.language)
  }, [handleClick, i18n.language])

  return (
    <StyledBlock p={p} id={id}>
      {title && (
        <Label p="0" bgColor="transparent" fontWeight="600">
          {title}
        </Label>
      )}
      <StyledBlock
        onClick={() => {
          !disabled && setShow(!show);
        }}
        ref={hoverRef}
      >
        <StyledPrefix>
          <ArrowDown size="2em" up={show} />
        </StyledPrefix>
        <ContainerSelectedValue error={required && !value}>
          <ItemsMultiSelect bgColor="transparent" muted={!value}>
            {getLabel()}
          </ItemsMultiSelect>
        </ContainerSelectedValue>
      </StyledBlock>
      {show && (
        <PopupSelect className={show ? "panel active" : "panel"} ref={ref}>
          {items &&
            sortTop(items, topValues).map((item) => (
              <ItemLi
                key={item.value}
                onClick={() => {
                  handleLeave && handleLeave()
                  changeItem(item.value);
                  handleClick && handleClick(item.value)
                  setShow(false);
                }}
              >
                {item.label}
              </ItemLi>
            ))}
        </PopupSelect>
      )}
    </StyledBlock>
  );
};

export default Select;

export interface ISelectHook {
  changeItem: React.Dispatch<React.SetStateAction<StrNum | undefined>>;
  value: StrNum | undefined;
}

export const useSelect = (initial?: StrNum | undefined, language?: boolean): ISelectHook => {
  const [value, setValue] = useState<StrNum | undefined>(initial);
  const {i18n} = useTranslation('home')


  return {
    changeItem: setValue,
    value
  };
};
